import { createSlice } from '@reduxjs/toolkit'
import {
  addTreatmentPlan,
  updateTreatmentPlan,
  deleteTreatmentPlan,
  fetchTreatmentPlanbyPatientId,
} from '../actions/treatment-plan.action'
import { ITreatmentPlan } from '@dataTypes/treatmentPlan.types'

interface TreatmentPlanState {
  treatmentPlans: ITreatmentPlan[]
  patientTreatmentPlans: ITreatmentPlan[]
  loading: boolean
  error: string | null
  latestAddedPlanId?: string
}

const initialState: TreatmentPlanState = {
  treatmentPlans: [],
  patientTreatmentPlans: [],
  loading: false,
  error: null,
  latestAddedPlanId: undefined,
}

const treatmentPlanSlice = createSlice({
  name: 'treatmentPlan',
  initialState,
  reducers: {
    clearLatestAddedPlanId(state) {
      state.latestAddedPlanId = undefined
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTreatmentPlanbyPatientId.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchTreatmentPlanbyPatientId.fulfilled, (state, action) => {
        state.patientTreatmentPlans = action.payload
        state.loading = false
        state.latestAddedPlanId = undefined
      })
      .addCase(fetchTreatmentPlanbyPatientId.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload as string
      })
      .addCase(addTreatmentPlan.fulfilled, (state, action) => {
        state.patientTreatmentPlans.push(action.payload)
        state.treatmentPlans.push(action.payload)
        state.latestAddedPlanId = action.payload.tp_id
      })
      .addCase(updateTreatmentPlan.fulfilled, (state, action) => {
        const index = state.patientTreatmentPlans.findIndex(
          (p) => p.tp_id === action.payload.tp_id,
        )
        if (index !== -1) {
          state.patientTreatmentPlans[index] = action.payload
        }
      })
      .addCase(deleteTreatmentPlan.fulfilled, (state, action) => {
        state.patientTreatmentPlans = state.patientTreatmentPlans.filter(
          (p) => p.tp_id !== action.payload,
        )
      })
  },
})

export const { clearLatestAddedPlanId } = treatmentPlanSlice.actions
export default treatmentPlanSlice.reducer
